export class Item {
    id?: number;
    name: string;
    isSelected: boolean;
    children: Item[];
}
